import {actions, ActionType} from './action';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../../common/util/redux';
import {TimeTableDay} from '../../timeTable/type';
import {INITIAL_SECOND_TABS} from '../common';
import {HomeTabPage, IEventPopup, INoticePopup, ISecondTabs} from '../type';

export interface IStateHome {
  isInitialized: boolean;
  tabPage: HomeTabPage;
  secondTabs: ISecondTabs;
  secondTabClickCount: number;
  eventPopupList?: IEventPopup[];
  noticePopup?: INoticePopup;
  todayWeekday?: TimeTableDay;
  isPreserveQueryParams?: boolean;
}

const INITIAL_STATE: IStateHome = {
  isInitialized: false,
  tabPage: HomeTabPage.Ranking,
  secondTabs: INITIAL_SECOND_TABS,
  secondTabClickCount: 0,
  eventPopupList: undefined,
};

export default createReducer<IStateHome, ReducerActionHelper<typeof actions>>(
  INITIAL_STATE,
  {
    [ActionType.ChangeSecondTabSelected]: (state, action) => {
      const {tabPage, selected, isTabClick} = action.payload;
      const secondTabs = state.secondTabs[tabPage];
      if (selected && secondTabs?.tabList.find(({key}) => key === selected)) {
        secondTabs.selected = selected;
      }
      state.tabPage = tabPage;
      isTabClick && (state.secondTabClickCount += 1);
    },
    [ActionType.SetMessages]: (state, action) => {
      const {eventPopupList, noticePopup} = action.payload;
      state.eventPopupList = eventPopupList;
      state.noticePopup = noticePopup;
    },
    [ActionType.InitializeHome]: (state, action) => {
      // 랭킹탭은 `fetchRankingTab` 에서 selectedTab을 정의한다. (탭정보를 api요청을통해 알수있기때문에)
      const {initialTabPage, initialSecondTab, todayWeekday} = action.payload;

      const secondTabs = state.secondTabs[initialTabPage];

      state.secondTabs[HomeTabPage.TimeTable].selected = todayWeekday;
      state.todayWeekday = todayWeekday;

      if (secondTabs) {
        state.tabPage = initialTabPage;
        initialSecondTab &&
          secondTabs.tabList.find(item => item.key === initialSecondTab) &&
          (secondTabs.selected = initialSecondTab);
      }

      state.isInitialized = true;
    },
    ...createBasicReducerHandlers({
      setValueActionType: ActionType.SetValue,
      setPropertyValuesActionType: ActionType.SetPropertyValues,
    }),
  }
);
